export const columns = [
  {
    id: 'clientName',
    label: 'Client name',
    width: '150px',
  },
  {
    id: 'createdBy',
    label: 'Assigned by',
    width: '150px',
  },
  {
    id: 'createdDate',
    label: 'Assigned date',
    width: '150px',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
    width: '150px',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
    width: '150px',
  },
]
